// AccessAdminLayout — chrome for /admin/access (PLEX-4095).
//
// Gated like the Entitlements pages: tenant-admins of this cell and Plex
// admins. The backend enforces the same (@requires_groups on rd's
// /api/admin/access/*). Soft gate (render a message) rather than redirect, so
// a shared URL gives a sensible page.

import { inject, observer } from "mobx-react";
import { Outlet } from "react-router-dom";

import { withAuthentication } from "../../components/AuthenticateUser";
import "../admin-entitlements/AdminEntitlements.css"; // the shared admin chrome
import "./AdminAccess.css";

export const AccessAdminGate = ({ userStore, children }) => {
  if (!userStore?.isTenantAdmin && !userStore?.isAdmin) {
    return (
      <div className="adminEnt stone-page">
        <div className="gate">
          <h2>Tenant administrators only</h2>
          <p>
            This area shows who can reach each program and project in your
            organization, and lets you grant or revoke that access.
          </p>
          <p className="adminAcc-gate-note">
            Ask your tenant administrator to add you to the
            <strong> tenant-admin </strong>
            group if you need access.
          </p>
        </div>
      </div>
    );
  }
  return (
    <div className="adminEnt stone-page">
      <div className="adminEnt-shell adminAcc-shell">
        <main className="adminEnt-page adminAcc-page">{children}</main>
      </div>
    </div>
  );
};

const AccessAdminLayout = ({ userStore }) => (
  <AccessAdminGate userStore={userStore}>
    <Outlet />
  </AccessAdminGate>
);

export default withAuthentication(inject("userStore")(observer(AccessAdminLayout)));
